import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../api/api';

const Analytics = () => {
  const { t } = useTranslation();
  const [seasons, setSeasons] = useState([]);
  const [activeSeason, setActiveSeason] = useState(null);

  useEffect(() => {
    const fetchSeasons = async () => {
      try {
        const res = await api.get('/seasons');
        setSeasons(res.data);
        const active = res.data.find(s => s.isActive);
        if (active) setActiveSeason(active);
        else if (res.data.length > 0) setActiveSeason(res.data[0]);
      } catch (err) { /* ignore */ }
    };
    fetchSeasons();
  }, []);

  const cards = [
    { key: 'teamRankings', icon: '🏀', path: '/analytics/team-rankings', color: 'from-blue-500 to-blue-700' },
    { key: 'gmRankings', icon: '👤', path: '/analytics/gm-rankings', color: 'from-purple-500 to-purple-700' },
    { key: 'headToHead', icon: '⚔️', path: '/analytics/head-to-head', color: 'from-red-500 to-red-700' },
    { key: 'formTrends', icon: '📈', path: '/analytics/team-rankings', color: 'from-green-500 to-green-700' },
    { key: 'homeAway', icon: '🏠', path: '/analytics/team-rankings', color: 'from-orange-500 to-orange-700' },
  ];

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="text-center mb-10">
        <h1 className="text-4xl font-bold text-gray-800 dark:text-gray-200 mb-2">📊 {t('analytics.title')}</h1>
        <p className="text-gray-600 dark:text-gray-400 text-lg">{t('analytics.subtitle')}</p>
        {activeSeason && (
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">{t('analytics.currentSeason')}: {activeSeason.name}</p>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
        {cards.map(card => (
          <Link
            key={card.key}
            to={card.path}
            className={`bg-gradient-to-br ${card.color} text-white rounded-xl p-6 shadow-lg dark:shadow-gray-900 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200`}
          >
            <div className="text-4xl mb-3">{card.icon}</div>
            <h3 className="text-xl font-bold mb-2">{t(`analytics.cards.${card.key}.title`)}</h3>
            <p className="text-white text-opacity-80 text-sm">{t(`analytics.cards.${card.key}.desc`)}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Analytics;
